<form #form="ngForm" class="cliente-contrato-form" novalidate *ngIf="entity">
  <sgt-accordion [settings]="{ isCollapsed: true }">
    <h6 header class="m-0">Contrato</h6>

    <div class="row">
      <div class="form-group col-12">
        <div class="custom-control custom-switch">
          <input
            type="checkbox"
            class="custom-control-input"
            [(ngModel)]="entity.possuiContrato"
            name="possuiContrato"
            id="possuiContrato"
            [disabled]="!canEdit"
          >
          <label class="custom-control-label" for="possuiContrato">Possui Contrato</label>
        </div>
        <p class="form-text text-muted">Indica se o cliente possui contrato comercial firmado com a empresa</p>
      </div>
    </div>

    <ng-container *ngIf="entity.possuiContrato">

      <!-- Badge de Status -->
      <div class="row" *ngIf="exibirStatus">
        <div class="col-12 cliente-contrato-form__status">
          <span class="badge" [ngClass]="statusBadgeClass">
            {{ statusText }}
          </span>
        </div>
      </div>

      <!-- Número do Contrato -->
      <div class="row">
        <div class="form-group col-12 col-md-6">
          <label for="numeroContrato" class="col-form-label">Número do Contrato</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="entity.numeroContrato"
            name="numeroContrato"
            id="numeroContrato"
            maxlength="100"
            [disabled]="!canEdit"
          >
          <p class="form-text text-muted">Identificador do contrato (ex: CTR-2026/001)</p>
        </div>
      </div>

      <!-- Datas -->
      <div class="row">
        <div class="form-group col-12 col-md-6">
          <label for="dataInicioContrato" class="col-form-label">Data de Início</label>
          <sgt-datepicker
            [(ngModel)]="entity.dataInicioContrato"
            name="dataInicioContrato"
            id="dataInicioContrato"
            #dataInicioContrato="ngModel"
            [ngControl]="dataInicioContrato"
            [required]="canEdit"
            [disabled]="!canEdit"
            [readonly]="!canEdit"
            (change)="onDataAlterada()">
          </sgt-datepicker>
          <sgt-form-control-error
            *ngIf="dataInicioContrato.errors?.required && dataInicioContrato.dirty"
            msgError="A data de início é obrigatória">
          </sgt-form-control-error>
        </div>

        <div class="form-group col-12 col-md-6">
          <label for="dataValidadeContrato" class="col-form-label">Data de Validade</label>
          <sgt-datepicker
            [(ngModel)]="entity.dataValidadeContrato"
            name="dataValidadeContrato"
            id="dataValidadeContrato"
            #dataValidadeContrato="ngModel"
            [ngControl]="dataValidadeContrato"
            [required]="canEdit"
            [disabled]="!canEdit"
            [readonly]="!canEdit"
            (change)="onDataAlterada()">
          </sgt-datepicker>
          <sgt-form-control-error
            *ngIf="dataValidadeContrato.errors?.required && dataValidadeContrato.dirty"
            msgError="A data de validade é obrigatória">
          </sgt-form-control-error>
        </div>
      </div>

      <!-- Percentual de Desconto -->
      <div class="row">
        <div class="form-group col-12 col-md-4">
          <label for="percDescontoContrato" class="col-form-label">Desconto do Contrato</label>
          <div class="input-group cliente-contrato-form__desconto__input">
            <sgt-decimal2
              [(ngModel)]="entity.percDescontoContrato"
              name="percDescontoContrato"
              id="percDescontoContrato"
              #percDescontoContrato="ngModel"
              [ngControl]="percDescontoContrato"
              [min]="0"
              [max]="100"
              [digits]="2"
              [disabled]="!canEdit">
            </sgt-decimal2>
            <div class="input-group-append">
              <span class="input-group-text">%</span>
            </div>
          </div>
          <p class="form-text text-muted">Percentual de desconto fixo negociado no contrato</p>
        </div>
      </div>

      <!-- Arquivo do Contrato -->
      <div class="row">
        <div class="form-group col-12">
          <label class="col-form-label">Arquivo do Contrato</label>

          <!-- Card vazio (sem arquivo) -->
          <div class="cliente-contrato-form__arquivo__card cliente-contrato-form__arquivo__card--empty" *ngIf="!possuiArquivo">
            <div class="cliente-contrato-form__arquivo__card__icon">
              <i class="far fa-file"></i>
            </div>
            <div class="cliente-contrato-form__arquivo__card__content">
              <span class="cliente-contrato-form__arquivo__card__nome text-muted">Nenhum arquivo selecionado</span>
              <div class="cliente-contrato-form__arquivo__card__acoes">
                <label
                  for="inputArquivoContrato"
                  class="btn btn-sm btn-link p-0 mb-0"
                  *ngIf="canEdit && !isUploading">
                  <i class="fa fa-upload"></i> Selecionar arquivo
                </label>
              </div>
            </div>
          </div>

          <!-- Card do arquivo -->
          <div class="cliente-contrato-form__arquivo__card" *ngIf="possuiArquivo">
            <div class="cliente-contrato-form__arquivo__card__icon">
              <i [class]="arquivoIconClass"></i>
            </div>
            <div class="cliente-contrato-form__arquivo__card__content">
              <span class="cliente-contrato-form__arquivo__card__nome">{{ nomeArquivo }}</span>
              <!-- Progresso de upload -->
              <div class="cliente-contrato-form__arquivo__card__progress" *ngIf="isUploading">
                <div class="progress">
                  <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style="width: 100%"></div>
                </div>
                <small class="text-muted">Enviando...</small>
              </div>
              <!-- Ações -->
              <div class="cliente-contrato-form__arquivo__card__acoes" *ngIf="!isUploading">
                <button
                  type="button"
                  class="btn btn-sm btn-link p-0"
                  *ngIf="entity.urlArquivoContrato"
                  (click)="visualizarContrato()">
                  <i class="fa fa-external-link"></i> Visualizar
                </button>
                <label
                  for="inputArquivoContrato"
                  class="btn btn-sm btn-link p-0 mb-0"
                  *ngIf="canEdit">
                  <i class="fa fa-refresh"></i> Trocar
                </label>
              </div>
            </div>
            <button
              type="button"
              class="cliente-contrato-form__arquivo__card__remove"
              *ngIf="canEdit && !isUploading"
              (click)="removerArquivo()">
              <i class="fa fa-times"></i>
            </button>
          </div>

          <!-- Input file oculto -->
          <input
            type="file"
            id="inputArquivoContrato"
            class="d-none"
            accept=".pdf,.doc,.docx"
            (change)="onFileSelected($event)"
          >
        </div>
      </div>

      <!-- Observações -->
      <div class="row">
        <div class="form-group col-12 cliente-contrato-form__observacoes">
          <label for="observacoesContrato" class="col-form-label">Observações do Contrato</label>
          <textarea
            class="form-control"
            [(ngModel)]="entity.observacoesContrato"
            name="observacoesContrato"
            id="observacoesContrato"
            rows="3"
            sgtAutosize
            [disabled]="!canEdit"
          ></textarea>
          <p class="form-text text-muted">Informações adicionais sobre cláusulas, condições especiais ou observações relevantes do contrato</p>
        </div>
      </div>

      <!-- Notificações de Vencimento -->
      <div class="row">
        <div class="form-group col-12">
          <h6 class="cliente-contrato-form__sub-bloco">Notificações de Vencimento</h6>
          <p class="form-text text-muted">
            Por padrão, este contrato segue os marcos e destinatários configurados em Configurações → Clientes.
            Preencha aqui apenas para personalizar este cliente.
          </p>
        </div>

        <div class="form-group col-12 col-md-6">
          <label class="col-form-label">
            Marcos de notificação (dias)
            <i
              class="fa fa-info-circle text-muted ml-1"
              sgtTooltip="Defina com quantos dias de antecedência você deseja ser avisado sobre o vencimento deste contrato. Use valores negativos para receber avisos após o vencimento (ex.: -7 envia um aviso 7 dias depois do vencimento). Os dias informados aqui sobrescrevem os padrões configurados pela empresa."
              tooltipPosition="top"
              sgtTooltipClass="sgt-tooltip--multiline"
              ></i>
          </label>
          <sgt-tokenfield-input
            mode="number"
            [tokens]="marcosTokens"
            [settings]="marcosSettings"
            (tokensChange)="onMarcosChange($event)">
          </sgt-tokenfield-input>
        </div>

        <div class="form-group col-12 col-md-6">
          <label class="col-form-label">
            E-mails para notificação
            <i
              class="fa fa-info-circle text-muted ml-1"
              sgtTooltip="Informe os e-mails que devem receber os avisos de vencimento deste contrato. Eles são combinados com os e-mails padrões configurados pela empresa."
              tooltipPosition="top"
              sgtTooltipClass="sgt-tooltip--multiline"
              ></i>
          </label>
          <sgt-tokenfield-input
            [tokens]="emailsTokens"
            [settings]="emailsSettings"
            (tokensChange)="onEmailsChange($event)">
          </sgt-tokenfield-input>
        </div>
      </div>

    </ng-container>
  </sgt-accordion>
</form>
